import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { bool, string } from 'prop-types';
import { useFormContext } from '../FormContext';

const FormButton = (props) => {
  const { label, variant, className, fullWidth } = props;

  const context = useFormContext();
  const { setSubmitted } = context;

  return (
    <div className={className}>
      <Button
        variant={variant}
        type="submit"
        fullWidth={fullWidth}
        onClick={() => setSubmitted(true)}
        role="button"
      >
        {label}
      </Button>
    </div>
  );
};

FormButton.displayName = 'FormButton';

FormButton.propTypes = {
  label: string.isRequired,
  variant: string.isRequired,
  fullWidth: bool,
  className: string
};

FormButton.defaultProps = {
  className: '',
  fullWidth: false
};

export { FormButton };
